import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

// Registering the Chart.js components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ReportChart = ({ activeIds = [], labels, datasets }) => {
    const updatedDatasets =
        activeIds.length === 0
            ? datasets
            : datasets.filter((dataset) => activeIds.includes(dataset.id));

    const data = {
        labels: labels,
        datasets: updatedDatasets,
    };

    const options = {
        responsive: true,
        interaction: {
            mode: "index",
            intersect: false,
        },
        scales: {
            y1: {
                type: "linear",
                display: true,
                position: "left",
                ticks: {
                    callback: function (value) {
                        return value.toLocaleString(); // Show large numbers in readable format
                    },
                },
            },
            y2: {
                type: "linear",
                display: true,
                position: "right",
                ticks: {
                    callback: function (value) {
                        return value.toLocaleString(); // Format numbers
                    },
                },
                grid: {
                    drawOnChartArea: false, // Avoid overlapping grid lines
                },
            },
            x: {
                ticks: {
                    color: "#000", // X-axis label color
                },
            },
        },
        plugins: {
            legend: {
                display: false,
                labels: {
                    color: "#000", // Legend label color
                },
            },
        },
    };

    return (
        <div className="w-full h-[600px] min-h-96 mt-10">
            <Line data={data} options={options} />
        </div>
    );
};

export default ReportChart;
